import BaseModel from './BaseModel';

class OfferAddon extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.offer_id = data.offer_id || "";
    this.addon_id = data.addon_id || "";
    this.circle_id = data.circle_id || "";
    this.start_date = data.start_date || "";
    this.end_date = data.end_date || "";
    this.discount_amount = data.discount_amount || "";
    this.discount_percentage = data.discount_percentage || "";
    this.percentage_max_discount_amount = data.percentage_max_discount_amount || "";
    this.offer_ids = data.offer_ids || [];
    this.offer_ids = data.offer_id === '' ? [...this.offer_ids] : [];
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      offer_ids: this.offer_ids,
      offer_addon: {
        addon_id: this.addon_id,
        circle_id: this.circle_id ,
        start_date: this.start_date ,
        discount_amount: this.discount_amount ,
        discount_percentage: this.discount_percentage ,
        percentage_max_discount_amount: this.percentage_max_discount_amount ,
        end_date: this.end_date,
      },
    }
  }

  toEditApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      offer_addon: {
        offer_id: this.offer_id,
        addon_id: this.addon_id,
        circle_id: this.circle_id,
        start_date: this.start_date,
        discount_amount: this.discount_amount,
        discount_percentage: this.discount_percentage,
        percentage_max_discount_amount: this.percentage_max_discount_amount,
        end_date: this.end_date,
      },
    }
  }

  validations = (field) => {
    return {
      circle_id: () => {
        if(this[field] === "") {
          this.errors.circle_id = "This field is required.";
        } else{
          delete this.errors.circle_id;
        }
      },
      addon_id: () => {
        if(this[field] === "") {
          this.errors.addon_id = "This field is required.";
        } else{
          delete this.errors.addon_id;
        }
      },
      offer_ids: () => {
        if(this.offer_ids.length === 0 && this.offer_id === "") {
          this.errors.offer_ids = "Select atleast one offer.";
          delete this.errors.offer_id;
        } else{
          delete this.errors.offer_ids;
          delete this.errors.offer_id;
        }
      },
      offer_id: () => {
        if(this.offer_id === '' && this.offer_ids.length === 0) {
          this.errors.offer_id = "This field is required.";
          delete this.errors.offer_ids
        } else{
          delete this.errors.offer_ids
          delete this.errors.offer_id;
        }
      },
      start_date: () => {
        if(this[field] === "") {
          this.errors.start_date = "This field is required.";
        } else{
          if(this.end_date && this[field] > this.end_date){
            this.errors.start_date = "Start Date must be smaller than end date";
            } else {
            delete this.errors.start_date;
            }
        }
      },
      end_date: () => {
        if(this[field] === "") {
          this.errors.end_date = "This field is required.";
        } else{
          if(this.start_date && this[field] < this.start_date) {
            this.errors.end_date = "End Date must be greater than start date";
          } else{
            delete this.errors.end_date;
          }
        }
      },
      discount_amount: () => {
        if(this[field] === "" && this.discount_percentage === "") {
          this.errors.discount_amount = "This field is required.";
        } else{
          delete this.errors.discount_amount;
        }
      },
      discount_percentage: () => {
        if(this[field] === "" && this.discount_amount === "") {
          this.errors.discount_percentage = "This field is required.";
        } else{
            if(this[field] > 100) {
              this.errors.discount_percentage = "Discount amount cannot be greater than 100.";
            } else if(this[field] < 0) {
              this.errors.discount_percentage = "Discount amount cannot be smaller than 0.";
            } else{
              delete this.errors.discount_percentage;
            }
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default OfferAddon;
